import React from "react";

const LinkenInIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_20790_1650)">
        <path
          d="M30.9244 0H3.07558C1.377 0 0 1.377 0 3.07558V30.9243C0 32.623 1.377 34 3.07558 34H30.9243C32.623 34 34 32.623 34 30.9243V3.07558C34 1.377 32.623 0 30.9244 0ZM10.521 29.3578C10.521 29.8522 10.1203 30.2529 9.62601 30.2529H5.81605C5.32171 30.2529 4.92101 29.8522 4.92101 29.3578V13.3867C4.92101 12.8923 5.32171 12.4916 5.81605 12.4916H9.62601C10.1203 12.4916 10.521 12.8923 10.521 13.3867V29.3578ZM7.72103 10.9861C5.72206 10.9861 4.10154 9.36558 4.10154 7.36661C4.10154 5.36764 5.72206 3.74712 7.72103 3.74712C9.72 3.74712 11.3405 5.36764 11.3405 7.36661C11.3405 9.36558 9.72008 10.9861 7.72103 10.9861ZM30.4318 29.4299C30.4318 29.8844 30.0633 30.2529 29.6088 30.2529H25.5205C25.066 30.2529 24.6975 29.8844 24.6975 29.4299V21.9385C24.6975 20.821 25.0253 17.0414 21.777 17.0414C19.2574 17.0414 18.7463 19.6284 18.6437 20.7894V29.4299C18.6437 29.8844 18.2753 30.2529 17.8207 30.2529H13.8666C13.4121 30.2529 13.0436 29.8844 13.0436 29.4299V13.3146C13.0436 12.8601 13.4121 12.4916 13.8666 12.4916H17.8207C18.2752 12.4916 18.6437 12.8601 18.6437 13.3146V14.7079C19.5779 13.3058 20.9664 12.2236 23.9227 12.2236C30.4693 12.2236 30.4318 18.3397 30.4318 21.7002V29.4299Z"
          fill="#0077B7"
        />
      </g>
      <defs>
        <clipPath id="clip0_20790_1650">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinkenInIcon;
